function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import handlers from './mixins/handlers';
import helpers from './mixins/helpers';
import preparations from './mixins/preparations';
import props from './mixins/props';
import watchers from './mixins/watchers';
export default {
  name: 'agile',
  mixins: [handlers, helpers, preparations, props, watchers],
  data: function data() {
    return {
      slides: [],
      slidesClonedBefore: [],
      slidesClonedAfter: [],
      autoplayInterval: null,
      autoplayTimeout: null,
      pauseAutoPlay: false,
      autoplayStart: null,
      autoplayRemaining: null,
      // autoplayStatus: false,
      // autoplayTimeout: null,
      currentSlide: null,
      mouseDown: false,
      dragStartX: 0,
      dragStartY: 0,
      dragDistance: 0,
      swipeDistance: 50,
      translateX: 0,
      transitionDelay: 0,
      widthWindow: 0,
      widthContainer: 0,
      widthSlide: 0,
      settings: {}
    };
  },
  computed: {
    canGoToPrev: function canGoToPrev() {
      return this.settings.infinite || this.currentSlide > 0;
    },
    canGoToNext: function canGoToNext() {
      return this.settings.infinite || this.currentSlide < this.slidesCount - 1;
    },
    clonedSlides: function clonedSlides() {
      return !this.settings.unagile && !this.settings.fade && this.settings.infinite;
    },
    breakpoints: function breakpoints() {
      return !this.initialSettings.responsive ? [] : this.initialSettings.responsive.map(function (item) {
        return item.breakpoint;
      });
    },
    currentBreakpoint: function currentBreakpoint() {
      var _this = this;

      var breakpoints = this.breakpoints.map(function (item) {
        return item;
      }).reverse();
      return this.initialSettings.mobileFirst ? breakpoints.find(function (item) {
        return item < _this.widthWindow;
      }) || 0 : breakpoints.find(function (item) {
        return item > _this.widthWindow;
      }) || null;
    },
    allSlides: function allSlides() {
      return this.clonedSlides ? [].concat(_toConsumableArray(this.slidesClonedBefore), _toConsumableArray(this.slides), _toConsumableArray(this.slidesClonedAfter)) : this.slides;
    },
    slidesCount: function slidesCount() {
      return this.slides.length;
    },
    allSlidesCount: function allSlidesCount() {
      return this.allSlides.length;
    },
    marginX: function marginX() {
      var marginX = this.clonedSlides ? this.slidesCount * this.widthSlide : 0; // Center mode margin

      if (this.settings.centerMode) {
        marginX -= (Math.floor(this.settings.slidesToShow / 2) - +(this.settings.slidesToShow % 2 === 0)) * this.widthSlide;
      }

      return this.settings.rtl ? marginX : -1 * marginX;
    }
  },
  created: function created() {
    // Read settings from options object
    if (this.options) {
      for (var key in this.options) {
        this.initialSettings[key] = this.options[key];
      }
    } // Sort breakpoints


    if (this.initialSettings.responsive) {
      this.initialSettings.responsive.sort(this.compare);
    } // Set first load settings


    Object.assign(this.settings, this.initialSettings);
  },
  mounted: function mounted() {
    // Windows resize listener
    window.addEventListener('resize', this.getWidth); // Mouse and touch events

    if ('ontouchstart' in window) {
      this.$refs.track.addEventListener('touchstart', this.handleMouseDown);
      this.$refs.track.addEventListener('touchend', this.handleMouseUp);
      this.$refs.track.addEventListener('touchmove', this.handleMouseMove);
    } else {
      this.$refs.track.addEventListener('mousedown', this.handleMouseDown);
      this.$refs.track.addEventListener('mouseup', this.handleMouseUp);
      this.$refs.track.addEventListener('mousemove', this.handleMouseMove);
    } // Init


    this.reload();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.getWidth);
    this.$refs.track.removeEventListener('ontouchstart' in window ? 'touchstart' : 'mousedown', this.handleMouseDown);
    this.$refs.track.removeEventListener('ontouchstart' in window ? 'touchend' : 'mouseup', this.handleMouseUp);
    this.$refs.track.removeEventListener('ontouchstart' in window ? 'touchmove' : 'mousemove', this.handleMouseMove);
    this.disableAutoPlay();
  },
  methods: {
    // Reload carousel
    reload: function reload() {
      this.getWidth();
      this.prepareSettings();
      this.prepareSlides();
      this.prepareCarousel();
      this.toggleFade();
    },
    toggleFade: function toggleFade() {
      var enabled = !this.settings.unagile && this.settings.fade;

      for (var i = 0; i < this.slidesCount; i++) {
        this.slides[i].style.transition = enabled ? 'opacity ' + this.settings.timing + ' ' + this.settings.speed + 'ms' : 'none';
        this.slides[i].style.transform = enabled ? "translate(-".concat(i * this.widthSlide, "px)") : 'none';
      }
    },
    toggleAutoPlay: function toggleAutoPlay() {
      var _this2 = this;

      var enabled = !this.settings.unagile && this.settings.autoplay;

      if (!this.autoplayInterval && enabled) {
        this.autoplayInterval = setInterval(function () {
          if (!document.hidden) {
            if (!_this2.canGoToNext) {
              _this2.disableAutoPlay();
            } else {
              _this2.goToNext();
            }
          }
        }, this.settings.autoplaySpeed);
      } else {
        this.disableAutoPlay();
      }
    },
    restartAutoPlay: function restartAutoPlay() {
      this.disableAutoPlay();
      this.toggleAutoPlay();
    },
    disableAutoPlay: function disableAutoPlay() {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    },
    clearAutoPlayPause: function clearAutoPlayPause() {
      clearTimeout(this.autoplayTimeout);
      this.autoplayRemaining = null;
    },
    disableScroll: function disableScroll() {
      document.ontouchmove = function (e) {
        return e.preventDefault();
      };
    },
    enableScroll: function enableScroll() {
      document.ontouchmove = function () {
        return true;
      };
    },
    // Return current slide index
    getCurrentSlide: function getCurrentSlide() {
      return this.currentSlide;
    },
    // Return current breakpoint
    getCurrentBreakpoint: function getCurrentBreakpoint() {
      return this.currentBreakpoint;
    },
    // Return settings for current breakpoint
    getCurrentSettings: function getCurrentSettings() {
      return this.settings;
    },
    // Return initial settings
    getInitialSettings: function getInitialSettings() {
      return this.initialSettings;
    },
    // Go to next slide
    goToNext: function goToNext() {
      if (this.canGoToNext) {
        this.goTo(this.currentSlide + 1);
      }
    },
    // Go to previous slide
    goToPrev: function goToPrev() {
      if (this.canGoToPrev) {
        this.goTo(this.currentSlide - 1);
      }
    },
    // Go to slide
    goTo: function goTo(n) {
      var _this3 = this;

      var transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var asNav = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      // Break goTo() if unagile is active
      if (this.settings.unagile) {
        return false;
      }

      if (!asNav) {
        this.settings.asNavFor.forEach(function (carousel) {
          if (carousel) {
            carousel.goTo(n, transition, true);
          }
        });
      }

      var realNextSlide = n;

      if (transition) {
        if (this.settings.infinite && n < 0) {
          realNextSlide = this.slidesCount - 1;
        } else if (n >= this.slidesCount) {
          realNextSlide = 0;
        }

        this.$emit('beforeChange', {
          currentSlide: this.currentSlide,
          nextSlide: realNextSlide
        });
        this.currentSlide = realNextSlide;

        if (n !== realNextSlide) {
          setTimeout(function () {
            _this3.goTo(realNextSlide, false);
          }, this.settings.speed);
        }
      }

      var translateX = !this.settings.fade ? n * this.widthSlide * this.settings.slidesToScroll : 0;
      this.transitionDelay = transition ? this.speed : 0;
      this.translateX = this.settings.rtl ? translateX : -1 * translateX;
    }
  }
};